import { HeaderLogin } from '../../components/Login/HeaderLogin';
import {Login} from '../../components/Login/Login';

export const LoginView = () => {
  return (
    <>
      <HeaderLogin/>
      <Login/>
    </>
  );
};
